const traffic = {
  repair: {
    handleTime: 'Repair date',
    mileage: 'Repair mileage(km)',
    items: 'Repair items',
    edit: 'Edit repair',
    add: 'Add repair',
    itemIdList: 'Repair items',
    basicRepair: 'Basic Repair',
    deepRepair: 'Deep Repair',
    custom: 'customize',
    errorRepair: 'Please select repair items',
  },
  maintain: {
    handleTime: 'Maintain date',
    mileage: 'Maintain mileage(km)',
    items: 'Maintain items',
    edit: 'Edit maintain',
    add: 'Add maintain',
    itemIdList: 'Maintain items',
    nextTime: 'Next maintain date',
    nextMileage: 'Next maintain mileage',
    nextItems: 'Next maintain items',
    basicMaintain: 'Basic Maintain',
    deepMaintain: 'Deep Maintain',
    cleanMaintain: 'Clean Maintain',
    customized: 'Customized',
    errorMaintain: 'Please select maintain items',
    nextRemind:'Whether to remind',
    tx:'Remind',
    btx:"Don't remind",
    errornext:'Please select the next maintenance item'
  },
  selectCar: 'Select car',
  licensePlate: 'License plate',
  errorLicensePlate: 'Please enter license plate',
  errorMileage: 'Please enter mileage(Digit)',
  errorTime: 'Please select date',
  remark: 'Remark'
}
export default traffic